// @ts-nocheck
import { plugin } from './plugin';
import * as Plugin_0 from '/home/runner/work/app/app/src/app.tsx';
import * as Plugin_1 from '/home/runner/work/app/app/src/.umi-production/plugin-access/rootContainer.ts';
import * as Plugin_2 from '/home/runner/work/app/app/src/.umi-production/plugin-dva/runtime.tsx';
import * as Plugin_3 from '../plugin-initial-state/runtime';
import * as Plugin_4 from '/home/runner/work/app/app/src/.umi-production/plugin-locale/runtime.tsx';
import * as Plugin_5 from '../plugin-model/runtime';

  plugin.register({
    apply: Plugin_0,
    path: '/home/runner/work/app/app/src/app.tsx',
  });
  plugin.register({
    apply: Plugin_1,
    path: '/home/runner/work/app/app/src/.umi-production/plugin-access/rootContainer.ts',
  });
  plugin.register({
    apply: Plugin_2,
    path: '/home/runner/work/app/app/src/.umi-production/plugin-dva/runtime.tsx',
  });
  plugin.register({
    apply: Plugin_3,
    path: '../plugin-initial-state/runtime',
  });
  plugin.register({
    apply: Plugin_4,
    path: '/home/runner/work/app/app/src/.umi-production/plugin-locale/runtime.tsx',
  });
  plugin.register({
    apply: Plugin_5,
    path: '../plugin-model/runtime',
  });
